import { createContext, Dispatch, SetStateAction } from 'react';

export const IdsHistoryContext = createContext<{
  idsHistoryContext: number[];
  setIdsHistoryContext: Dispatch<SetStateAction<number[]>>;
}>({
  idsHistoryContext: [],
  setIdsHistoryContext: () => null,
});
